import api from "./api";
import { apiDomain } from "./constants";

export async function getTicketsDowntime({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/downtime`, {
    params: {
      start,
      end,
    },
  });

  return data;
}

export async function getEmergencyCorrectiveTicketsByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/emergency-corrective`, {
    params: {
      start,
      end,
    },
  });

  return data;
}

export async function getProgrammedCorrectiveTicketsByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/programmed-corrective`, {
    params: {
      start,
      end,
    },
  });

  return data;
}

export async function getTicketsByModalityByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/modality`, {
    params: {
      start,
      end,
    },
  });

  return data;
}

export async function getManagementReportsTicketsCsv({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/csv`, {
    params: {
      start,
      end,
    },
    responseType: "blob"
  });

  return data;
}

export async function getReportCharts({ start, end }) {
  const { data, headers } = await api.get(`${apiDomain}/management-reports/zip`, {
    params: {
      start,
      end,
    },
    responseType: "blob"
  });
  
  const filename = headers["content-disposition"]
    .split("filename=")[1]
    .replace(/"/g, "")
    .trim();

  return { 
    file: data,
    filename,
  };
}

export async function getOnTimeServiceByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/on-time-service`, {
    params: { start, end }
  });

  return data;
}

export async function getOnTimeSolvedByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/on-time-solved`, {
    params: { start, end }
  });

  return data;
}

export async function getDidNotServiceByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/did-not-service`, {
    params: { start, end }
  });

  return data;
}

export async function getDidNotSolveByMonth({ start, end }) {
  const { data } = await api.get(`${apiDomain}/management-reports/did-not-solve`, {
    params: { start, end }
  });

  return data;
}
